function initializeObserver() {
  // Callback function to execute when the target element is in view
  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("wiggle");
        // Optionally, you can unobserve the element if you only want the callback to run once
        observer.unobserve(entry.target);
      }
    });
  };

  // Create the Intersection Observer
  const observer = new IntersectionObserver(callback, {
    root: null, // Use the viewport as the root
    rootMargin: "-40% 0px", // Centering the element vertically in the viewport
    threshold: 1, // Trigger when 100% of the target is in view
  });

  // Select the element containing the <svg>
  const target = document.querySelector(".product-info__accordion svg");

  // Start observing the target element
  if (target) {
    observer.observe(target);
  } else {
    console.error("No element containing an <svg> found.");
  }
}

// Initialize the observer when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", initializeObserver);
